import {
  transformOperation,
  transformOperationList,
  transformOperationPeriodsPaginatedResponse,
} from '@/common/integrations/menhir/employee/operations/operations.dto';
import {
  IGetOperationsParams,
  IMenhirOperation,
  IMenhirOperationItem,
  TGetOperationsPeriodsParams,
  TMenhirOperationPeriod,
} from '@/common/integrations/menhir/employee/operations/operations.types';
import { menhirClient } from '@/common/integrations/menhir/menhir.client';
import {
  MENHIR_ENDPOINTS,
  endpointFor,
} from '@/common/integrations/menhir/menhir.endpoints';
import { IMenhirPaginationResponse } from '@/common/types/menhir/general';

export const getOperations = ({
  page,
  perPage,
  pagination,
  usage,
  filters,
}: IGetOperationsParams) =>
  menhirClient
    .get<null, { operations: IMenhirPaginationResponse<IMenhirOperationItem> }>(
      MENHIR_ENDPOINTS.EMPLOYEE.OPERATIONS.ROOT,
      {
        params: {
          page: page,
          per_page: perPage,
          pagination,
          usage,
          'filters[category]': filters?.category,
          'filters[type]': filters?.type,
          'filters[executed_from]': filters?.from,
          'filters[executed_to]': filters?.to,
        },
      }
    )
    .then((envelope) => transformOperationList(envelope.operations));

export const getOperationDetail = (id: string) =>
  menhirClient
    .get<
      null,
      { operation: IMenhirOperation }
    >(endpointFor(MENHIR_ENDPOINTS.EMPLOYEE.OPERATIONS.DETAIL, id))
    .then((envelope) => {
      return transformOperation(envelope.operation);
    });

export const getOperationsPeriods = ({
  page,
  perPage,
  pagination,
}: TGetOperationsPeriodsParams) =>
  menhirClient
    .get<null, { periods: IMenhirPaginationResponse<TMenhirOperationPeriod> }>(
      MENHIR_ENDPOINTS.EMPLOYEE.OPERATIONS.PERIODS,
      {
        params: {
          page: page,
          per_page: perPage,
          pagination,
        },
      }
    )
    .then(({ periods }) => transformOperationPeriodsPaginatedResponse(periods));
